import { error } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

export const UpdatePlaidAccount = gql`
  mutation UpdatePlaidAccount($input: PlaidUpdateItemV2Input!) {
    plaidUpdateItemV2(input: $input) {
      __typename
      ... on PlaidUpdateItemV2Success {
        message
      }
      ... on PlaidUpdateItemV2Error {
        ...error
      }
    }
  }
  ${error}
`;
